// media_id が空のイベントは、API側の集計（storeeel_report.rb の row.media_id.present?）で
// 必ず捨てられるためレポートには一切現れない。送っても GA4 のイベント数が増えるだけなので、
// 送信・localStorage保存の手前で弾く。
//
// 空になりうるのは連携配信（feedFolderResolver.js）で content.hashid が取れず、
// 誤集計を避けるために mediaAsset.id を意図的に空文字にしたケース。
// 経路によって「弾く/そのまま送る」が分かれていたため、判定をここに集約する。
export const isTrackableMediaId = (mediaId) => String(mediaId ?? '').trim() !== '';
